import { EMPTY_OBJECT } from '../../../constants/common'
import { UserProfileHeaderFooter } from '../../User'

import { useUserProfilePageHeaderFooterActions } from './UserProfilePageHeaderFooter.hooks'
import { UserProfilePageHeaderFooterPrimaryAction } from './UserProfilePageHeaderFooterPrimaryAction'
import { UserProfilePageHeaderFooterSecondaryAction } from './UserProfilePageHeaderFooterSecondaryAction'

function UserProfilePageHeaderFooter({
  actionsConfig = EMPTY_OBJECT,
  isLoading,
}) {
  const { actionHandlers, getUploadFileInputProps } =
    useUserProfilePageHeaderFooterActions()

  return (
    <UserProfileHeaderFooter
      PrimaryAction={UserProfilePageHeaderFooterPrimaryAction}
      SecondaryAction={UserProfilePageHeaderFooterSecondaryAction}
      actionHandlers={actionHandlers}
      actionsConfig={actionsConfig}
      getUploadFileInputProps={getUploadFileInputProps}
      isLoading={isLoading}
    />
  )
}

export default UserProfilePageHeaderFooter
